"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reservationHomeEditApi = reservationHomeEditApi;
exports.reservationHomeInfoApi = reservationHomeInfoApi;
exports.reservationStoreEditApi = reservationStoreEditApi;
exports.reservationStoreInfoApi = reservationStoreInfoApi;
exports.workOrderAssignApi = workOrderAssignApi;
exports.workOrderDetailApi = workOrderDetailApi;
exports.workOrderForceFinishApi = workOrderForceFinishApi;
exports.workOrderListApi = workOrderListApi;
exports.workOrderMarkApi = workOrderMarkApi;
exports.workOrderOverViewApi = workOrderOverViewApi;
exports.workOrderOverViewNumApi = workOrderOverViewNumApi;
exports.workOrderReassignApi = workOrderReassignApi;
exports.workOrderStatusNumApi = workOrderStatusNumApi;
exports.workOrderUpdateAgreementApi = workOrderUpdateAgreementApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 编辑到店服务预约信息
 * @param pram
 */
function reservationStoreEditApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/reservation/config/store/edit',
    method: 'post',
    data: data
  });
}

/**
 * 到店服务详情
 */
function reservationStoreInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/reservation/config/store/info',
    method: 'get'
  });
}

/**
 * 上门服务详情
 */
function reservationHomeInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/reservation/config/home/info',
    method: 'get'
  });
}
/**
 * 编辑上门服务详情
 * @param pram
 */
function reservationHomeEditApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/reservation/config/home/edit',
    method: 'post',
    data: data
  });
}
/**
 * 预约工单甘特图
 * @param pram
 */
function workOrderOverViewApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/work/order/overView',
    method: 'get',
    params: params
  });
}

/**
 * 工单甘特图各状态数量
 * @param pram
 */
function workOrderOverViewNumApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/work/order/overView/num',
    method: 'get',
    params: params
  });
}

/**
 * 预约工单分页列表
 * @param pram
 */
function workOrderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/work/order/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取工单各状态数量
 * @param pram
 */
function workOrderStatusNumApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/work/order/status/num',
    method: 'get',
    params: params
  });
}

/**
 * 工单详情
 * @param pram
 */
function workOrderDetailApi(workOrderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/work/order/detail/".concat(workOrderNo),
    method: 'get'
  });
}

/**
 * 商户派单
 * @param pram
 */
function workOrderAssignApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/work/order/assign",
    method: 'post',
    data: data
  });
}

/**
 * 商户改派
 * @param pram
 */
function workOrderReassignApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/work/order/reassign",
    method: 'post',
    data: data
  });
}

/**
 * 商户改约
 * @param pram
 */
function workOrderUpdateAgreementApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/work/order/updateAgreement",
    method: 'post',
    data: data
  });
}

/**
 * 商户备注工单
 * @param pram
 */
function workOrderMarkApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/work/order/mark",
    method: 'post',
    data: data
  });
}

/**
 * 商户强制完成工单
 * @param pram
 */
function workOrderForceFinishApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/work/order/forceFinish",
    method: 'post',
    data: data
  });
}